import { PATIENT_STATUSES } from 'src/constants';
import { Patient } from 'src/interfaces';

export const isPatientActive = (p?: Patient) =>
  !!p && !p.deceasedDate && p.status === PATIENT_STATUSES.ACTIVE;
